import React from "react"

export const CopyrightNotice: React.FC = () => {
    return (
        <h4>Copyright 2021, Richard Milne</h4>
    )
}